import { ALIGNMENT_EDGES } from '../constants';

/**
 * Canvas center alignment strategy
 * Shows alignment lines when objects are near canvas center
 */
export const centerAlignmentStrategy = {
  /**
   * Check for alignments with canvas center
   * @param {fabric.Object} activeObject - The object being moved
   * @param {fabric.Canvas} canvas - The fabric canvas
   * @param {Object} options - Alignment options
   * @returns {Object} Alignment data with lines array
   */
  checkAlignment(activeObject, canvas, options) {
    const alignmentLines = [];
    const canvasWidth = canvas.getWidth();
    const canvasHeight = canvas.getHeight();
    const canvasWidthCenter = canvasWidth / 2;
    const canvasHeightCenter = canvasHeight / 2;

    const objectCenter = activeObject.getCenterPoint();
    const centerLineMargin = options.centerLineMargin;
    const snapThreshold = options.snapThreshold || 5;

    // Check vertical center alignment
    const verticalDistance = Math.abs(objectCenter.x - canvasWidthCenter);
    if (verticalDistance <= centerLineMargin) {
      const isSnapped = verticalDistance <= snapThreshold;
      alignmentLines.push({
        type: 'vertical',
        x: canvasWidthCenter,
        y1: 0,
        y2: canvasHeight,
        alignmentType: ALIGNMENT_EDGES.CENTER_VERTICAL,
        isCanvasCenter: true,
        isSnapped: isSnapped,
        color: isSnapped ? options.snapIndicatorColor : options.lineColor,
        width:
          (options.centerLineWidth || options.lineWidth) *
          (isSnapped ? options.snappedLineWidthMultiplier || 1.2 : 1),
      });
    }

    // Check horizontal center alignment
    const horizontalDistance = Math.abs(objectCenter.y - canvasHeightCenter);
    if (horizontalDistance <= centerLineMargin) {
      const isSnapped = horizontalDistance <= snapThreshold;
      alignmentLines.push({
        type: 'horizontal',
        y: canvasHeightCenter,
        x1: 0,
        x2: canvasWidth,
        alignmentType: ALIGNMENT_EDGES.CENTER_HORIZONTAL,
        isCanvasCenter: true,
        isSnapped: isSnapped,
        color: isSnapped ? options.snapIndicatorColor : options.lineColor,
        width:
          (options.centerLineWidth || options.lineWidth) *
          (isSnapped ? options.snappedLineWidthMultiplier || 1.2 : 1),
      });
    }

    return { lines: alignmentLines };
  },

  /**
   * Get alignment lines for this strategy
   * @returns {Array} Array of line definitions
   */
  getAlignmentLines() {
    // This method is called by AlignmentManager if needed
    // Currently handled in checkAlignment
    return [];
  },
};
